import Service from '@ember/service'

export default class WindowService extends Service {
  getWindow = window
}

declare module '@ember/service' {
  interface Registry {
    window: WindowService
  }
}
